module.exports = __webpack_public_path__ + "static/media/banner-bloqueio.0232ee4f.png";